// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"172":"2c8ba010f185023b","185":"d8063144fa2da2b1"}[chunkId] + ".css";
};